// @ts-nocheck 802c4ee9
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_subscribe'],
      sections: [addPanel.sections.getSections().contact.subscribeFormsSection],
    };
  },
};
